<form *ngIf="form" [formGroup]="form">
  <div class="ui-g-12">
    <div class="ui-g-6 ui-md-6 form-control">
      <span class="label">{{ 'campaign.emissionStartDate' | translate }}</span>
      <app-kv-calendar
        #emissionStartField
        [inputName]="'emissionDateStart'"
        [formData]="form"
        [startDateSelector]="true"
        [endDateInputName]="'emissionDateEnd'"
        [endDateCalendar]="emissionEndField"
      >
      </app-kv-calendar>
    </div>
    <div class="ui-g-6 ui-md-6 form-control">
      <span class="label">{{ 'campaign.emissionEndDate' | translate }}</span>
      <app-kv-calendar
        #emissionEndField
        [inputName]="'emissionDateEnd'"
        [formData]="form"
        [endDateSelector]="true"
        [startDateInputName]="'emissionDateStart'"
        [startDateCalendar]="emissionStartField"
      >
      </app-kv-calendar>
    </div>
  </div>
  <div class="ui-g-12">
    <div class="ui-g-6 ui-md-6 form-control">
      <span class="label">{{ 'campaign.fruitionStartDate' | translate }}</span>
      <app-kv-calendar
        #fruitionStartField
        [inputName]="'fruitionDateStart'"
        [formData]="form"
        [startDateSelector]="true"
        [endDateInputName]="'fruitionDateEnd'"
        [endDateCalendar]="fruitionEndField"
      >
      </app-kv-calendar>
    </div>
    <div class="ui-g-6 ui-md-6 form-control">
      <span class="label">{{ 'campaign.fruitionEndDate' | translate }}</span>
      <app-kv-calendar
        #fruitionEndField
        [inputName]="'fruitionDateEnd'"
        [formData]="form"
        [endDateSelector]="true"
        [startDateInputName]="'fruitionDateStart'"
        [startDateCalendar]="fruitionStartField"
      >
      </app-kv-calendar>
    </div>
  </div>
  <div class="ui-g-12 text-center">
    <span
      class="input-error-notification"
      *ngIf="datesError">
      {{ 'campaign.couponDatesError' | translate }}
    </span>
    <button
      class="k-generic-btn"
      type="button"
      pButton
      icon="fa fa-check"
      label="{{'common.save' | translate}}"
      (click)="save()">
    </button>
  </div>
</form>



// WEBPACK FOOTER //
// ./src/app/views/campaign-2.0/coupon-list/coupon-form/coupon-form.component.html